import { render, staticRenderFns } from "./labor.vue?vue&type=template&id=73bdcb0e&scoped=true&lang=pug"
import script from "./labor.vue?vue&type=script&lang=js"
export * from "./labor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bdcb0e",
  null
  
)

/* custom blocks */
import block0 from "./labor.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports